import React from 'react';

const defaultContextValue = {
  channel: 'desktop',
  configService: {},
  cookie: {},
  customer: {},
  dataType: '',
  deliveryZip: '',
  experiment: {},
  hosts: {},
  isDebugMode: false,
  isLocal: false,
  isSPAEnabled: false,
  mounted: false,
  nearByStores: [],
  path: '/',
  referer: '',
  segment: '',
  store: {}
};

const DataProviderContext = React.createContext(defaultContextValue);

export default DataProviderContext;
